import React, { useState, useEffect, DragEvent, useCallback } from 'react';
import HttpHelper from '../utils/HttpHelper';

interface Assessment {
    id: number;
    title: string;
  }

export function useAssessmentManager(initialSearchQuery = '') {
    const GET_ASSESSMENTS_ENDPOINT = `assessments`;
    const [assessmentsList, setAssessmentsList] = useState<any[]>([]);
    const [selectedAssessments, setSelectedAssessments] = useState<any[]>([]);
    const [searchQuery, setSearchQuery] = useState('');

    const handleSearch = async () => {
        // Backend expects `title` parameter (same as ManageAssessmentsTable)
        const query = searchQuery.trim();
        const searchEndpoint =
            query.length === 0
                ? `${GET_ASSESSMENTS_ENDPOINT}`
                : `${GET_ASSESSMENTS_ENDPOINT}?title=${encodeURIComponent(query)}`;
        try {
            const response = await HttpHelper.get(searchEndpoint);
            if (response) {
                setAssessmentsList(response);
            }
        } catch (error) {
            console.error('Failed to fetch filtered assessments', error);
        }
    };


    useEffect(() => {
        const getAssessments = async (searchQuery = '') => {
            try {
                const q = searchQuery.trim();
                const url = q.length === 0 ? `${GET_ASSESSMENTS_ENDPOINT}` : `${GET_ASSESSMENTS_ENDPOINT}?title=${encodeURIComponent(q)}`;
                const response = await HttpHelper.get(url);
                if (response) {
                    setAssessmentsList(response);
                }
            } catch (error) {
                console.error('Failed to fetch assessments', error);
            }
        };

        getAssessments(searchQuery);
    }, [searchQuery]);


    const updateSelectedAssessments = useCallback((assessments: Assessment[]) => {
        setSelectedAssessments(assessments);
    }, []);

    const handleSelectAssessment = (selectedAssessment: any) => {
        setSelectedAssessments((prevSelected) => {
            const exists = prevSelected.some(assessment => assessment.id === selectedAssessment.id);
            if (exists) {
                return prevSelected.filter(assessment => assessment.id !== selectedAssessment.id);
            } else {
                return [...prevSelected, selectedAssessment];
            }
        });
    };

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(event.target.value);
    };

    const handleDrop = (event: DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        const droppedItemId = event.dataTransfer.getData("text/plain");
        let updatedSelectedAssessments = [...selectedAssessments];
        const droppedItemIndex = updatedSelectedAssessments.findIndex(assessment => assessment.id.toString() === droppedItemId);
        if (droppedItemIndex !== -1) {
            const [reorderedItem] = updatedSelectedAssessments.splice(droppedItemIndex, 1);
            updatedSelectedAssessments = [...updatedSelectedAssessments, reorderedItem];
            setSelectedAssessments(updatedSelectedAssessments);
        }
    };

    const handleDragStart = (event: DragEvent<HTMLDivElement>, id: number) => {
        event.dataTransfer.setData("text/plain", id.toString());
    };

    const handleDragOver = (event: DragEvent<HTMLDivElement>) => {
        event.preventDefault();

    };

    return {
        assessmentsList,
        selectedAssessments,
        searchQuery,
        handleSearch,
        updateSelectedAssessments,
        handleSelectAssessment,
        handleSearchChange,
        handleDrop,
        handleDragStart,
        handleDragOver,
    };
};
